export const SET_CONNECTION_STATUS = 'SET_CONNECTION_STATUS'

export function setConnectionStatus(connectionStatus) {
  return {
    type: SET_CONNECTION_STATUS,
    connectionStatus
  }
}



// WEBPACK FOOTER //
// ./src/actions/connectionStatus.js